// FETCH ALL STYLE
export const FETCH_SKU_MASTER_HEADER_REQUEST = 'FETCH_SKU_MASTER_HEADER_REQUEST';
export const FETCH_SKU_MASTER_HEADER_SUCCESS = 'FETCH_SKU_MASTER_HEADER_SUCCESS';
export const FETCH_SKU_MASTER_HEADER_FAILURE = 'FETCH_SKU_MASTER_HEADER_FAILURE';

export const FETCH_SKU_MASTER_HEADER_SIZE_REQUEST = 'FETCH_SKU_MASTER_HEADER_SIZE_REQUEST';
export const FETCH_SKU_MASTER_HEADER_SIZE_SUCCESS = 'FETCH_SKU_MASTER_HEADER_SIZE_SUCCESS';
export const FETCH_SKU_MASTER_HEADER_SIZE_FAILURE = 'FETCH_SKU_MASTER_HEADER_SIZE_FAILURE';

// FETCH ALL STYLE
export const FETCH_SKU_MASTER_SIZE_HEADER_REQUEST = 'FETCH_SKU_MASTER_SIZE_HEADER_REQUEST';
export const FETCH_SKU_MASTER_SIZE_HEADER_SUCCESS = 'FETCH_SKU_MASTER_SIZE_HEADER_SUCCESS';
export const FETCH_SKU_MASTER_SIZE_HEADER_FAILURE = 'FETCH_SKU_MASTER_SIZE_HEADER_FAILURE';

export const FETCH_SKU_MASTER_HEADER_WITH_ID_REQUEST = 'FETCH_SKU_MASTER_HEADER_WITH_ID_REQUEST';
export const FETCH_SKU_MASTER_HEADER_WITH_ID_SUCCESS = 'FETCH_SKU_MASTER_HEADER_WITH_ID_SUCCESS';
export const FETCH_SKU_MASTER_HEADER_WITH_ID_FAILURE = 'FETCH_SKU_MASTER_HEADER_WITH_ID_FAILURE';

export const FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_REQUEST = 'FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_REQUEST';
export const FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_SUCCESS = 'FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_SUCCESS';
export const FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_FAILURE = 'FETCH_SKU_MASTER_DETAILS_WITH_STYLE_NAME_FAILURE';

export const FETCH_SKU_MASTER_DETAILS_GRID_REQUEST = 'FETCH_SKU_MASTER_DETAILS_GRID_REQUEST';
export const FETCH_SKU_MASTER_DETAILS_GRID_SUCCESS = 'FETCH_SKU_MASTER_DETAILS_GRID_SUCCESS';
export const FETCH_SKU_MASTER_DETAILS_GRID_FAILURE = 'FETCH_SKU_MASTER_DETAILS_GRID_FAILURE';

// CREATE STYLE
export const CREATE_SKU_MASTER_HEADER_REQUEST = 'CREATE_SKU_MASTER_HEADER_REQUEST';
export const CREATE_SKU_MASTER_HEADER_SUCCESS = 'CREATE_SKU_MASTER_HEADER_SUCCESS';
export const CREATE_SKU_MASTER_HEADER_FAILURE = 'CREATE_SKU_MASTER_HEADER_FAILURE';

// CREATE STYLE
export const CREATE_SKU_MASTER_HEADER_IMAGE_REQUEST = 'CREATE_SKU_MASTER_HEADER_IMAGE_REQUEST';
export const CREATE_SKU_MASTER_HEADER_IMAGE_SUCCESS = 'CREATE_SKU_MASTER_HEADER_IMAGE_SUCCESS';
export const CREATE_SKU_MASTER_HEADER_IMAGE_FAILURE = 'CREATE_SKU_MASTER_HEADER_IMAGE_FAILURE';

// UPDATE STYLE
export const UPDATE_SKU_MASTER_HEADER_REQUEST = 'UPDATE_SKU_MASTER_HEADER_REQUEST';
export const UPDATE_SKU_MASTER_HEADER_SUCCESS = 'UPDATE_SKU_MASTER_HEADER_SUCCESS';
export const UPDATE_SKU_MASTER_HEADER_FAILURE = 'UPDATE_SKU_MASTER_HEADER_FAILURE';

// UPDATE STYLE
export const UPDATE_SKU_MASTER_SIZE_HEADER_REQUEST = 'UPDATE_SKU_MASTER_SIZE_HEADER_REQUEST';
export const UPDATE_SKU_MASTER_SIZE_HEADER_SUCCESS = 'UPDATE_SKU_MASTER_SIZE_HEADER_SUCCESS';
export const UPDATE_SKU_MASTER_SIZE_HEADER_FAILURE = 'UPDATE_SKU_MASTER_SIZE_HEADER_FAILURE';

// FETCH SINGLE STATE OF STYLE
export const FETCH_SINGLE_SKU_MASTER_HEADER_REQUEST = 'FETCH_SINGLE_SKU_MASTER_HEADER_REQUEST';
export const FETCH_SINGLE_SKU_MASTER_HEADER_SUCCESS = 'FETCH_SINGLE_SKU_MASTER_HEADER_SUCCESS';
export const FETCH_SINGLE_SKU_MASTER_HEADER_FAILURE = 'FETCH_SINGLE_SKU_MASTER_HEADER_FAILURE';

// DELETE STYLE
export const DELETE_SKU_MASTER_HEADER_REQUEST = 'DELETE_SKU_MASTER_HEADER_REQUEST';
export const DELETE_SKU_MASTER_HEADER_SUCCESS = 'DELETE_SKU_MASTER_HEADER_SUCCESS';
export const DELETE_SKU_MASTER_HEADER_FAILURE = 'DELETE_SKU_MASTER_HEADER_FAILURE';

export const RESET_SKU_MASTER_HEADER_INFO = 'RESET_SKU_MASTER_HEADER_INFO';

export const CREATE_SKU_MASTER_HEADER_FORM = 'CREATE_SKU_MASTER_HEADER_FORM';

export const SET_ACTIVE_KEY_SKU_MASTER = 'SET_ACTIVE_KEY_SKU_MASTER';
export const SET_XLSX_DATA_OF_SKU_MASTER = 'SET_XLSX_DATA_OF_SKU_MASTER';

export const UPDATE_SKU_MASTER_HEADER_FORM = 'UPDATE_SKU_MASTER_HEADER_FORM';
export const UPDATE_SKU_MASTER_SIZE_HEADER_FORM = 'UPDATE_SKU_MASTER_SIZE_HEADER_FORM';

// NAVIGATE TO STYLE SKU_MASTER COMPONENT
export const NAVIGATE_SKU_MASTER_DETAIL = 'NAVIGATE_SKU_MASTER_DETAIL';

// NAVIGATE TO STYLE COMPONENT
export const NAVIGATE_SKU_MASTER_HEADER = 'NAVIGATE_SKU_MASTER_HEADER';

export const HANDLE_SKU_SIZE_MODAL = 'HANDLE_SKU_SIZE_MODAL';


// export const FETCH_COLOR_DATA = 'FETCH_COLOR_DATA'


export const FETCH_COLOR_DATA_REQUEST = 'FETCH_COLOR_DATA_REQUEST';
export const FETCH_COLOR_DATA_SUCCESS = 'FETCH_COLOR_DATA_SUCCESS';
export const FETCH_COLOR_DATA_FAILURE = 'FETCH_COLOR_DATA_FAILURE';


export const FETCH_SIZE_DATA_REQUEST = 'FETCH_SIZE_DATA_REQUEST';
export const FETCH_SIZE_DATA_SUCCESS = 'FETCH_SIZE_DATA_SUCCESS';
export const FETCH_SIZE_DATA_FAILURE = 'FETCH_SIZE_DATA_FAILURE';